import { createReducer } from '@reduxjs/toolkit'
import { SetSubscriptionAction } from '@store/reducers/subscription/actions'

import type { SubscriptionState } from './types'

const initial: SubscriptionState = {
  braintree: false,
  canceled: false,
  links: [],
  messages: [],
  payments: [],
  plan: 'plan_free',
  subscriptionType: 'annual',
  stats: [],
}

export const subscriptionReducer = createReducer(initial, (builder) => {
  builder.addCase(SetSubscriptionAction, (_, { payload }) => payload)
})
